export default __webpack_public_path__ + "static/media/Preg1.561688d4.jpg";